import { IClusterCredentialCreateRequest, IClusterCredentialCreateResponse, IClusterCredentialListItem, IClusterCredentialPageRequestParams } from "api/entities/cluster-credential";
import { DataService } from "./data-service";
import { IPage } from "api/entities/page";


class ClusterCredentialService extends DataService {
    constructor() {
        super("cluster/credential", 2);
      }


  getPage(requestParams: IClusterCredentialPageRequestParams): Promise<IPage<IClusterCredentialListItem>> {
    return this.api.get<IPage<IClusterCredentialListItem>>(null, requestParams);
  }

  get(credentialId: string): Promise<IClusterCredentialListItem> {
    return this.api.get<IClusterCredentialListItem>(credentialId, null);
  }

  create(request: IClusterCredentialCreateRequest) {
    return this.api.post<IClusterCredentialCreateResponse>(null, request)
  }

  nameValidator(clusterCredentialsName: string): Promise<boolean> {
    return this.getPage({ q: clusterCredentialsName, strict: true, fields: ['id', 'name'], deleted: true })
        .then(page => page.count === 0 || page.data.filter(x => x.name === clusterCredentialsName).length === 0);
  }

  delete(id: string) {
    return this.api.delete<IClusterCredentialListItem>(id);
  }
}

export const clusterCredentialService = new ClusterCredentialService()